"use client";

import { Table, TableBody, TableRow, TableHeader, TableHead } from "@oreme/ui";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { TimeserieTableRow } from "@/components";
import type { Timeserie } from "@/types";

interface TimeserieTableProps extends HTMLAttributes<HTMLDivElement> {
  data: Timeserie[];
}

function TimeserieTable({ data }: Readonly<TimeserieTableProps>): ReactElement {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="py-1">Nom</TableHead>
          <TableHead className="py-1">Date</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((timeserie): ReactElement => {
          return <TimeserieTableRow key={timeserie.id} timeserie={timeserie} />;
        })}
      </TableBody>
    </Table>
  );
}

export { TimeserieTable, type TimeserieTableProps };
